module.exports = __webpack_public_path__ + "static/media/research@2x.f51d8f3c.png";